import React from "react";
import { BinocularsIcon, FlagIcon, PresentationIcon, PuzzleIcon, SearchCheckIcon, BoxIcon } from "lucide-react";
import { Reveal } from "../Reveal";
import { palacioProcess } from "../../data/palacio";
const ICONS: Record<(typeof palacioProcess)[number]['icon'], BoxIcon> = {
  flag: FlagIcon,
  binoculars: BinocularsIcon,
  workshop: PresentationIcon,
  puzzle: PuzzleIcon,
  audit: SearchCheckIcon
};

/** The five discovery activities, read left to right in the order they happened. */
export function ProcessSteps() {
  return <ol className="grid gap-8 sm:grid-cols-2 lg:grid-cols-5 lg:gap-0 lg:divide-x lg:divide-line" data-id="element-660" data-mp="1hjmvmlv88z6i">
      {palacioProcess.map((step, i) => {
      const Icon = ICONS[step.icon];
      return <Reveal key={step.title} delay={Math.min(i, 4) * 0.04} className="lg:px-5 lg:first:pl-0 lg:last:pr-0" data-id="element-661" data-mp="1rfgcuijw5gum" data-mpi={i}>
            <li data-id="element-662" data-mp="13pm000zknsad">
              <Icon className="h-6 w-6 text-ink" strokeWidth={1.5} aria-hidden data-id="element-663" data-mp="13p2gifu9wvu8" />
              <h3 className="mt-4 text-[15px] font-semibold leading-snug text-fg" data-id="element-664" data-mp="yrasvy0nvvvu">{step.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-fg-muted" data-id="element-665" data-mp="nsmhr8aalqsa">{step.body}</p>
            </li>
          </Reveal>;
    })}
    </ol>;
}